
import { Droplet, MapPin, Calendar } from 'lucide-react';
import ServiceCard from './ServiceCard';
import { Link } from 'react-router-dom';

// Services data
const services = [{
  id: 1,
  title: "باحث الزيوت",
  description: "احصل على توصيات زيوت مخصصة لطراز وموديل مركبتك المحددة.",
  icon: <Droplet className="h-6 w-6" />,
  link: "/oil-finder",
  linkText: "اعثر على زيتك"
}, {
  id: 3,
  title: "اعثر على محلك",
  description: "اكتشف محلات تغيير الزيت والخدمة القريبة مع تقييمات العملاء الحقيقية.",
  icon: <MapPin className="h-6 w-6" />,
  link: "/shops",
  linkText: "اعثر على المحلات"
}, {
  id: 4,
  title: "المواعيد",
  description: "احجز وأدر مواعيد تغيير الزيت مع مقدم الخدمة المفضل لديك.",
  icon: <Calendar className="h-6 w-6" />,
  link: "/appointments",
  linkText: "احجز الآن"
}];

const ServicesSection = () => {
  return (
    <section className="section-padding bg-autocare-blue bg-[autocare-blue-dark]">
      <div className="page-container">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 font-semibold bg-autocare-blue/10 rounded-full mb-4 text-[autocare-gray-light] text-white">
            خدماتنا
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">حلول شاملة لرعاية السيارات</h2>
          <p className="max-w-2xl mx-auto text-[autocare-gray-medium] text-white">
            كل ما تحتاجه للحفاظ على تشغيل مركبتك بسلاسة، من تغيير الزيت إلى تذكيرات الصيانة.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map(service => (
            <ServiceCard 
              key={service.id} 
              title={service.title} 
              description={service.description} 
              icon={service.icon} 
              link={service.link} 
              linkText={service.linkText} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
